import React, { useState, useEffect, useRef } from 'react';
import { FiFilter, FiRotateCw, FiPlus, FiSearch, FiChevronDown } from "react-icons/fi";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format } from "date-fns";
import { enUS, es } from 'date-fns/locale';
import check from "../../assets/check.svg";
import { useNavigate } from 'react-router-dom';
import map from '../../assets/map.svg';
import { createInvoices, updateInvoices, paymentForInvoices, getAllShipment, getAllInvoices, getProfile, getAllClients } from '../../ApiController/ApiService';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useDashboard } from '../Context/Dashboardcontext';

const statusColors = {
    'In Transit': 'bg-blue-500',
    Delivered: 'bg-green-500',
    Delayed: 'bg-red-500',
    Pending: 'bg-yellow-400',
};

const drivers = [
    { id: 1, name: 'John Doe', avatar: 'https://i.pravatar.cc/40?img=1' },
    { id: 2, name: 'Jane Smith', avatar: 'https://i.pravatar.cc/40?img=2' },
    { id: 3, name: 'Mike Johnson', avatar: 'https://i.pravatar.cc/40?img=3' },
];

const Invoice = () => {
    const { t, i18n } = useTranslation();
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showDropdown2, setShowDropdown2] = useState(false);
    const [showDropdown3, setShowDropdown3] = useState(false);
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [selectedRegions1, setSelectedRegions1] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const dropdownRef = useRef(null);
    const dropdownRef2 = useRef(null);
    const dropdownRef3 = useRef(null);
    const calendarRef = useRef(null);
    const buttonRef = useRef(null);
    const buttonRef2 = useRef(null);
    const buttonRef3 = useRef(null);
    const buttonRef4 = useRef(null);
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState("Export");
    const [showModal, setShowModal] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [updatingInvoice, setUpdatingInvoice] = useState(null);
    const [updateFormData, setUpdateFormData] = useState({ status: '', paymentMethod: '' });
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [search, setSearch] = useState('');
    const [showDropdowns, setShowDropdowns] = useState(false);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [invoices, setInvoices] = useState([]);
    const [shipments, setShipments] = useState([]);
    const [locations, setLocations] = useState([]);

    const [clientForm, setClientForm] = useState([]);
    const [selectedClientId, setSelectedClientId] = useState("");
    const { userProfile } = useDashboard();

    // Removed bankDetails from initial state
    const [formData, setFormData] = useState({
        invoiceDate: '',
        dueDate: '',
        poNumber: '',
        referenceNotes: '',
        size: '',
        deliveryDate: '',
        address: '',
        billFrom: '',
        billTo: '',
        clientAddress: '',
        shipments: [{ shipmentId: '', description: '', containerNumber: '', originLocation: '', destinationLocation: '' }],
        quantity: '',
        rate: '',
        tax: '',
        total: '0.00',
        paymentMethod: t('invoice.paymentMethods.bankTransfer'),
        companyType: "Dispax",
        shippingMethod: '',
        additionalNotesForClient: '',
        city: '',
        country: '',
        pinCode: '',
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [calendarPosition, setCalendarPosition] = useState({ top: 0, left: 0 });

    const locale = i18n.language === 'es' ? es : enUS;

    const filteredDrivers = drivers.filter(driver =>
        driver.name.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        const fetchClients = async (page = 1) => {
            setError(null);
            try {
                const res = await getAllClients({ page, limit: 1000 });
                console.log('getAllClients', res);

                if (res.success && Array.isArray(res.data.data.docs)) {
                    setClientForm(res.data.data.docs);
                }
            } catch (err) {
                setError(err.message);
            }
        };

        fetchClients();
    }, []);

    console.log('clientForm', clientForm);

    const generateInvoiceNumber = () => {
        return `INV-${Math.floor(100000 + Math.random() * 900000)}`;
    };

    useEffect(() => {
        setFormData(prev => {
            const subtotal = (prev.quantity || 0) * (prev.rate || 0);
            const taxAmount = parseFloat(prev.tax || 0);
            const newTotal = (subtotal + taxAmount).toFixed(2);
            return {
                ...prev,
                total: newTotal,
            };
        });
    }, [formData.quantity, formData.rate, formData.tax]);

    useEffect(() => {
        if (showModal) {
            const fetchProfile = async () => {
                try {
                    const profile = await getProfile();
                    setFormData(prev => ({
                        ...prev,
                        billFrom: profile.fullName || t('invoice.companyName'),
                        address: profile.address || '',
                        city: profile.city || '',
                        country: profile.country || '',
                        pinCode: profile.pinCode || '',
                    }));
                } catch (err) {
                    console.error('Error fetching profile:', err);
                    setError(t('errors.fetchProfileFailed'));
                }
            };
            fetchProfile();
        }
    }, [showModal, t]);

    const downloadInvoicePDF = (invoice) => {
        const doc = new jsPDF();

        // ===== HEADER =====
        doc.setFont("helvetica", "bold");
        doc.setFontSize(16);
        doc.setTextColor(40, 40, 40);
        doc.text(t('invoice.title'), 105, 20, { align: "center" });

        // Company Info (Left)
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(invoice.billFrom || t('invoice.companyName'), 20, 30);
        doc.text(invoice.address || t('invoice.companyAddress'), 20, 36);

        // Invoice Details (Right)
        doc.setFontSize(10);
        doc.text(`${t('invoice.invoiceNumber')}: ${invoice.invoiceNumber}`, 190, 30, { align: "right" });
        doc.text(`${t('invoice.invoiceDate')}: ${format(new Date(invoice.invoiceDate), "dd MMM yyyy", { locale })}`, 190, 36, { align: "right" });
        doc.text(`${t('invoice.dueDate')}: ${format(new Date(invoice.dueDate), "dd MMM yyyy", { locale })}`, 190, 42, { align: "right" });

        // Separator Line
        doc.setDrawColor(200, 200, 200);
        doc.line(20, 48, 190, 48);

        // ===== BILL TO =====
        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.text(t('invoice.billTo'), 20, 60);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(invoice.billTo, 20, 68);
        if (invoice.clientAddress) {
            doc.text(invoice.clientAddress, 20, 74);
        }

        let tableStartY = invoice.clientAddress ? 85 : 80;

        // ===== TABLE =====
        const subtotal = (invoice.quantity || 0) * (invoice.rate || 0);
        const tax = parseFloat(invoice.tax || 0);
        const total = parseFloat(invoice.total || subtotal + tax);

        autoTable(doc, {
            startY: tableStartY,
            head: [[t('invoice.description'), t('invoice.rate'), t('invoice.quantity'), t('invoice.total')]],
            body: [
                ...invoice.shipments.map(shipment => [
                    shipment.description,
                    `$${parseFloat(invoice.rate).toFixed(2)}`,
                    invoice.quantity,
                    `$${parseFloat(invoice.rate * invoice.quantity).toFixed(2)}`
                ]),
                ['', '', t('invoice.subtotal'), `$${subtotal.toFixed(2)}`],
                ['', '', t('invoice.tax'), `$${tax.toFixed(2)}`],
                ['', '', { content: t('invoice.total'), styles: { fontStyle: 'bold' } }, { content: `$${total.toFixed(2)}`, styles: { fontStyle: 'bold' } }]
            ],
            theme: 'grid',
            headStyles: {
                fillColor: [111, 26, 255],
                textColor: [255, 255, 255],
                fontSize: 10,
                fontStyle: 'bold',
                halign: 'center',
                cellPadding: 3
            },
            bodyStyles: {
                fontSize: 9,
                textColor: [50, 50, 50],
                cellPadding: 3
            },
            alternateRowStyles: { fillColor: [245, 245, 245] },
            columnStyles: {
                0: { cellWidth: 90, halign: 'left' },
                1: { cellWidth: 30, halign: 'right' },
                2: { cellWidth: 30, halign: 'center' },
                3: { cellWidth: 30, halign: 'right' }
            },
            margin: { left: 20, right: 20 },
            styles: {
                lineColor: [200, 200, 200],
                lineWidth: 0.2,
                font: 'helvetica'
            }
        });

        // ===== PAYMENT INFO =====
        const finalY = doc.lastAutoTable.finalY || tableStartY;
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text(t('invoice.paymentInformation'), 20, finalY + 15);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(`${t('invoice.paymentMethod')}: ${invoice.paymentMethod}`, 20, finalY + 23);

        // Replaced Bank Details with Stripe Info here
        doc.text(`Payment Gateway: Secure Online Payment via Stripe`, 20, finalY + 30, { maxWidth: 170 });

        if (invoice.shippingMethod) {
            doc.text(`${t('invoice.shippingMethod')}: ${invoice.shippingMethod}`, 20, finalY + 37, { maxWidth: 170 });
        }

        // ===== NOTES =====
        const notesY = finalY + 45 + (invoice.shippingMethod ? 7 : 0);
        if (invoice.additionalNotesForClient) {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(11);
            doc.text(t('invoice.additionalNotes'), 20, notesY);
            doc.setFont("helvetica", "normal");
            doc.setFontSize(10);
            doc.text(invoice.additionalNotesForClient, 20, notesY + 8, { maxWidth: 170 });
        }

        // ===== FOOTER =====
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.setTextColor(120, 120, 120);
            doc.text(`${t('invoice.page')} ${i} ${t('invoice.of')} ${pageCount}`, 190, 290, { align: "right" });
            doc.text(t('invoice.thankYou'), 105, 290, { align: "center" });
        }

        doc.save(`Invoice_${invoice.invoiceNumber}.pdf`);
    };

    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                setLoading(true);
                setError('');
                const fromDate = selectedDates.length > 0 ? format(selectedDates[0], 'yyyy-MM-dd') : '';
                const toDate = selectedDates.length > 1 ? format(selectedDates[1], 'yyyy-MM-dd') : fromDate;
                const paymentMethod = selectedRegions.join(',');
                const status = selectedRegions1.join(',');
                const location = selectedLocations.join(',');

                const params = {
                    page: 1,
                    limit: 10,
                    paymentMethod: paymentMethod || undefined,
                    'shipmentId.status': status || undefined,
                    fromDate: fromDate || undefined,
                    toDate: toDate || undefined,
                    location: location || undefined,
                };

                const response = await getAllInvoices(params);
                let invoicesData = [];
                if (Array.isArray(response)) {
                    invoicesData = response;
                } else if (response.data?.docs) {
                    invoicesData = response.data.docs;
                } else if (response.docs) {
                    invoicesData = response.docs;
                } else if (response.data) {
                    invoicesData = response.data;
                } else {
                    throw new Error(t('errors.invalidResponseFormat'));
                }

                if (!Array.isArray(invoicesData)) {
                    console.error('Parsed invoices data is not an array:', invoicesData);
                    setInvoices([]);
                    setError(t('errors.invalidResponseFormat'));
                    return;
                }

                setInvoices(invoicesData);

                const uniqueLocations = [...new Set(invoicesData.flatMap(invoice => [
                    invoice.originLocation,
                    invoice.destinationLocation
                ]).filter(loc => loc && loc !== '0, 0'))];
                setLocations(uniqueLocations);

                const uniquePaymentMethods = [...new Set(invoicesData.map(invoice => invoice.paymentMethod).filter(pm => pm))];
                setPaymentMethods(uniquePaymentMethods);

                const uniqueStatuses = [...new Set(invoicesData.map(invoice => invoice.shipmentId?.status).filter(status => status))];
                setStatuses(uniqueStatuses);
            } catch (err) {
                console.error('Error fetching invoices:', err);
                setError(`${t('errors.fetchInvoicesFailed')}: ${err.message}`);
                setInvoices([]);
                setPaymentMethods([]);
                setStatuses([]);
            } finally {
                setLoading(false);
            }
        };
        fetchInvoices();
    }, [selectedDates, selectedRegions, selectedRegions1, selectedLocations, t]);

    useEffect(() => {
        if (showModal) {
            const fetchShipments = async () => {
                try {
                    const response = await getAllShipment({ limit: 100000 });

                    let shipmentsArray =
                        response?.docs ||
                        response?.data?.docs ||
                        response?.data ||
                        response ||
                        [];

                    let filteredClients;

                    if (userProfile?.aiPackageId) {
                        filteredClients = shipmentsArray;
                    } else {
                        filteredClients = shipmentsArray.filter(
                            (client) => client?.companyType === "Dispax"
                        );
                    }

                    if (Array.isArray(filteredClients)) {
                        setShipments(filteredClients);
                    } else {
                        setShipments([]);
                        setError(t("errors.fetchShipmentsFailed"));
                    }
                } catch (err) {
                    console.error("Error fetching shipments:", err);
                    setError(`${t("errors.fetchShipmentsFailed")}: ${err.message}`);
                    setShipments([]);
                }
            };

            fetchShipments();
        }
    }, [showModal, t, userProfile?.aiPackageId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                calendarRef.current &&
                !calendarRef.current.contains(event.target) &&
                buttonRef.current &&
                !buttonRef.current.contains(event.target)
            ) {
                setShowCalendar(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target) &&
                buttonRef2.current &&
                !buttonRef2.current.contains(e.target)
            ) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef2.current &&
                !dropdownRef2.current.contains(e.target) &&
                buttonRef3.current &&
                !buttonRef3.current.contains(e.target)
            ) {
                setShowDropdown2(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (
                dropdownRef3.current &&
                !dropdownRef3.current.contains(e.target) &&
                buttonRef4.current &&
                !buttonRef4.current.contains(e.target)
            ) {
                setShowDropdown3(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleCalendarToggle = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setCalendarPosition({
                top: rect.height + 5,
                left: window.innerWidth < 640 ? 0 : -rect.width / 2,
            });
        }
        setShowCalendar((prev) => !prev);
    };

    const toggleRegion = (region) => {
        setSelectedRegions(prev =>
            prev.includes(region)
                ? prev.filter(r => r !== region)
                : [...prev, region]
        );
    };

    const toggleRegion2 = (region1) => {
        setSelectedRegions1(prev =>
            prev.includes(region1)
                ? prev.filter(r => r !== region1)
                : [...prev, region1]
        );
    };

    const toggleLocation = (location) => {
        setSelectedLocations(prev =>
            prev.includes(location)
                ? prev.filter(l => l !== location)
                : [...prev, location]
        );
    };

    const openSuccessModal = () => {
        setShowModal(false);
        setIsSuccessModalOpen(true);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === 'total' || name === 'city' || name === 'country' || name === 'pinCode') return;

        if ((name === 'quantity' || name === 'rate' || name === 'tax') && (value < 0 || isNaN(value))) {
            setError(t('errors.invalidQuantityOrRate'));
            return;
        }
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleShipmentChange = (index, shipmentId) => {
        const selectedShipment = shipments.find(s => s._id === shipmentId);
        setFormData(prev => {
            const updatedShipments = [...prev.shipments];
            updatedShipments[index] = {
                ...updatedShipments[index],
                shipmentId,
                containerNumber: selectedShipment?.containerNumber || '',
                originLocation: selectedShipment?.origin || '',
                destinationLocation: selectedShipment?.destination || '',
                description: selectedShipment?.description || '',
            };
            return { ...prev, shipments: updatedShipments };
        });
    };

    const handleDescriptionChange = (index, value) => {
        setFormData(prev => {
            const updatedShipments = [...prev.shipments];
            updatedShipments[index] = { ...updatedShipments[index], description: value };
            return { ...prev, shipments: updatedShipments };
        });
    };

    const addShipmentField = () => {
        setFormData(prev => ({
            ...prev,
            shipments: [...prev.shipments, { shipmentId: '', description: '', containerNumber: '', originLocation: '', destinationLocation: '' }],
        }));
    };

    const removeShipmentField = (index) => {
        setFormData(prev => {
            const updatedShipments = prev.shipments.filter((_, i) => i !== index);
            return { ...prev, shipments: updatedShipments };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            if (!formData.billFrom || !formData.billTo || formData.shipments.some(s => !s.shipmentId)) {
                throw new Error(t('errors.requiredFields'));
            }

            const subtotal = (formData.quantity || 0) * (formData.rate || 0);
            const taxAmount = parseFloat(formData.tax || 0);
            const total = (subtotal + taxAmount).toFixed(2);

            const payload = {
                ...formData,
                invoiceDate: new Date(formData.invoiceDate).toISOString(),
                companyType: "Dispax",
                dueDate: new Date(formData.dueDate).toISOString(),
                deliveryDate: formData.deliveryDate ? new Date(formData.deliveryDate).toISOString() : null,
                total: total,
                shipments: formData.shipments.map(s => ({
                    shipmentId: s.shipmentId,
                    description: s.description,
                    containerNumber: s.containerNumber,
                    originLocation: s.originLocation,
                    destinationLocation: s.destinationLocation
                })),
            };

            const response = await createInvoices(payload);

            // if (response.status === 200 || response.success) {
            //     const res = await paymentForInvoices((response?.data?._id))

            //     if (res?.session?.url) {
            //         window.location.href = res.session.url;
            //     } else {
            //         console.error("Stripe URL not found");
            //     }
            //     openSuccessModal();
            //     const updatedInvoices = await getAllInvoices();
            //     let invoicesData = [];
            //     if (Array.isArray(updatedInvoices)) {
            //         invoicesData = updatedInvoices;
            //     } else if (updatedInvoices.data?.docs) {
            //         invoicesData = updatedInvoices.data.docs;
            //     } else if (updatedInvoices.docs) {
            //         invoicesData = updatedInvoices.docs;
            //     } else if (updatedInvoices.data) {
            //         invoicesData = updatedInvoices.data;
            //     } else {
            //         throw new Error(t('errors.invalidResponseFormat'));
            //     }
            //     setInvoices(invoicesData);

            //     // Reset form without bankDetails
            //     setFormData({
            //         invoiceDate: '',
            //         dueDate: '',
            //         poNumber: '',
            //         referenceNotes: '',
            //         size: '',
            //         deliveryDate: '',
            //         address: '',
            //         billFrom: '',
            //         billTo: '',
            //         clientAddress: '',
            //         shipments: [{ shipmentId: '', description: '', containerNumber: '', originLocation: '', destinationLocation: '' }],
            //         quantity: '',
            //         rate: '',
            //         tax: '',
            //         total: '0.00',
            //         paymentMethod: t('invoice.paymentMethods.bankTransfer'),
            //         shippingMethod: '',
            //         additionalNotesForClient: '',
            //         city: '',
            //         country: '',
            //         pinCode: '',
            //     });
            //     setSelectedClientId(""); 
            // } else {
            //     throw new Error(response.message || t('errors.invoiceCreationFailed'));
            // }

            {
                if (response.status === 200 || response.success) { }

                openSuccessModal();

            }
        } catch (err) {
            console.error('Error creating invoice:', err);
            setError(err.message || t('errors.invoiceCreationFailed'));
            toast.error(err.message || t('errors.invoiceCreationFailed'));
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const client = clientForm?.find(c => c._id === selectedClientId);
        if (client) {
            setFormData(prev => ({
                ...prev,
                billTo: client.email,
                clientAddress: client.address,
                email: client.email
            }));
        }
    }, [selectedClientId, clientForm]);

    const handleUpdateStatus = (invoice) => {
        setUpdatingInvoice(invoice);
        setUpdateFormData({
            status: invoice.status || 'Pending',
            paymentMethod: invoice.paymentMethod || ''
        });
        setShowUpdateModal(true);
    };

    const handleConfirmUpdate = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const response = await updateInvoices(updatingInvoice._id, updateFormData);
            
            if (response.success || response.status === 200) {
                toast.success("Invoice updated successfully");
                setShowUpdateModal(false);
                // Refresh invoices
                const fromDate = selectedDates.length > 0 ? format(selectedDates[0], 'yyyy-MM-dd') : '';
                const toDate = selectedDates.length > 1 ? format(selectedDates[1], 'yyyy-MM-dd') : fromDate;
                const params = {
                    page: 1,
                    limit: 10,
                    paymentMethod: selectedRegions.join(',') || undefined,
                    'shipmentId.status': selectedRegions1.join(',') || undefined,
                    fromDate: fromDate || undefined,
                    toDate: toDate || undefined,
                    location: selectedLocations.join(',') || undefined,
                };
                const updatedInvoices = await getAllInvoices(params);
                setInvoices(updatedInvoices.data?.docs || updatedInvoices.data || updatedInvoices || []);
            } else {
                throw new Error("Update failed");
            }
        } catch (err) {
            console.error("Update error:", err);
            toast.error("Failed to update invoice");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="text-white relative p-4 sm:p-6">
            <div className="flex items-center justify-between mb-4 sm:mb-6">
                <h1 className="text-xl sm:text-2xl font-semibold">{t('invoice.title')}</h1>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between mb-4 sm:mb-6 gap-4">
                <div className="flex flex-col sm:flex-row items-center bg-[#10194E] rounded-xl shadow-md w-full sm:w-auto">
                    <div className="flex items-center gap-2 px-4 py-3 sm:py-5 border-r border-[#1E2A60] text-white w-full sm:w-auto">
                        <FiFilter className="text-lg" />
                        <span className="text-sm">{t('invoice.filterBy')}</span>
                    </div>
                    <div className="relative w-full sm:w-auto">
                        <button
                            ref={buttonRef}
                            onClick={handleCalendarToggle}
                            className="px-4 py-3 sm:py-5 text-sm text-white border-r border-[#1E2A60] bg-transparent w-full sm:w-auto text-left"
                        >
                            {selectedDates.length > 0
                                ? selectedDates.map((date) => format(date, "PP", { locale })).join(" - ")
                                : t('invoice.date')}
                        </button>
                        {showCalendar && (
                            <div
                                ref={calendarRef}
                                className="absolute z-50 p-4 shadow-lg rounded w-full sm:w-auto"
                                style={{
                                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                    top: calendarPosition.top,
                                    left: calendarPosition.left,
                                }}
                            >
                                <DayPicker
                                    mode="range"
                                    selected={{ from: selectedDates[0], to: selectedDates[1] }}
                                    onSelect={(range) => setSelectedDates([range?.from, range?.to].filter(Boolean))}
                                    footer={
                                        <div className="pt-4">
                                            <div className="flex justify-start">
                                                <span className="text-sm text-gray-400">{t('invoice.selectDateRange')}</span>
                                            </div>
                                            <div className="flex justify-center mt-2">
                                                <button
                                                    onClick={() => setShowCalendar(false)}
                                                    className="bg-[#6F1AFF] text-white px-4 py-1 rounded text-sm"
                                                >
                                                    {t('invoice.apply')}
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    locale={locale}
                                />
                            </div>
                        )}
                    </div>
                    <div className="relative w-full sm:w-auto">
                        <button
                            ref={buttonRef2}
                            onClick={() => setShowDropdown(!showDropdown)}
                            className="bg-transparent text-white px-4 py-3 sm:py-5 text-sm border-r border-[#1E2A60] outline-none w-full sm:w-auto text-left"
                        >
                            {selectedRegions.length > 0 ? selectedRegions.join(', ') : t('invoice.paymentMethod')}
                        </button>
                        {showDropdown && (
                            <div
                                ref={dropdownRef}
                                style={{
                                    background: 'radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)',
                                }}
                                className="absolute left-0 sm:left-1/2 sm:-translate-x-1/2 top-full mt-2 w-full sm:w-[25rem] text-white rounded-2xl p-4 sm:p-6 z-50 shadow-lg"
                            >
                                <h2 className="text-base sm:text-lg font-semibold mb-4">{t('invoice.paymentMethod')}</h2>
                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                                    {paymentMethods.length > 0 ? (
                                        paymentMethods.map((method) => (
                                            <button
                                                key={method}
                                                onClick={() => toggleRegion(method)}
                                                className={`px-3 py-2 rounded-full border transition-all text-sm ${selectedRegions.includes(method)
                                                    ? 'bg-white text-black font-semibold'
                                                    : 'bg-[#1D2A85] hover:bg-[#2A3AA5]'
                                                    }`}
                                            >
                                                {t(`invoice.paymentMethods.${method.toLowerCase()}`, { defaultValue: method })}
                                            </button>
                                        ))
                                    ) : (
                                        <p className="text-sm text-gray-400">{t('invoice.noPaymentMethods')}</p>
                                    )}
                                </div>
                                <p className="text-sm text-gray-300 mb-3">{t('invoice.multiplePaymentMethods')}</p>
                                <div className="text-center">
                                    <button
                                        onClick={() => setShowDropdown(false)}
                                        className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] px-6 py-2 rounded-lg text-white font-semibold hover:opacity-90 text-sm"
                                    >
                                        {t('invoice.applyNow')}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    <button
                        onClick={() => {
                            setSelectedDates([]);
                            setSelectedRegions([]);
                            setSelectedRegions1([]);
                            setSelectedLocations([]);
                            setInvoices([]);
                        }}
                        className="flex items-center gap-1 px-4 py-3 sm:py-5 text-sm text-orange-400 hover:underline w-full sm:w-auto text-left"
                    >
                        <FiRotateCw className="text-sm" />
                        {t('invoice.resetFilter')}
                    </button>
                </div>

                <button
                    onClick={() => setShowModal(true)}
                    className="bg-gradient-to-r from-[#6E00FF] to-[#A627FF] hover:opacity-90 px-4 sm:px-5 py-2 rounded-xl text-white font-medium flex items-center gap-2 shadow-md w-full sm:w-auto"
                >
                    <FiPlus className="text-md" />
                    {t('invoice.createNewInvoice')}
                </button>
            </div>

            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div
                        className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-full sm:max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
                        style={{
                            background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
                        }}
                    >
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-2 right-4 text-xl sm:text-2xl font-bold"
                        >
                            ×
                        </button>

                        <h2 className="text-lg sm:text-xl font-bold mb-4">{t('invoice.createNewInvoice')}</h2>

                        <>
                            <form className="space-y-4" onSubmit={handleSubmit}>
                                <h3 className="text-sm text-cyan-400 font-semibold mt-4">{t('invoice.invoiceInformation')}</h3>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.invoiceDate')}</label>
                                    <input
                                        name="invoiceDate"
                                        type="date"
                                        value={formData.invoiceDate}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.dueDate')}</label>
                                    <input
                                        name="dueDate"
                                        type="date"
                                        value={formData.dueDate}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.poNumber')}</label>
                                    <input
                                        name="poNumber"
                                        value={formData.poNumber}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>

                                <h3 className="text-sm text-cyan-400 font-semibold mt-4">{t('invoice.shipmentContainerInformation')}</h3>
                                {formData.shipments.map((shipment, index) => (
                                    <div key={index} className="space-y-2 border-b border-gray-600 pb-4 mb-4">
                                        <div>
                                            <label className="text-sm block mb-1">{t('invoice.shipmentId')}</label>
                                            <select
                                                value={shipment.shipmentId}
                                                onChange={(e) => handleShipmentChange(index, e.target.value)}
                                                className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                                required
                                            >
                                                <option value="">{t('invoice.selectShipment')}</option>
                                                {shipments.length > 0 ? (
                                                    shipments.map(s => (
                                                        <option key={s._id} value={s._id}>
                                                            {s.containerNumber || t('invoice.shipmentIdFormat', { id: s._id.substring(0, 6) })}
                                                        </option>
                                                    ))
                                                ) : (
                                                    <option value="" disabled>{t('invoice.loadingShipments')}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div>
                                            <label className="text-sm block mb-1">{t('invoice.containerId')}</label>
                                            <input
                                                value={shipment.containerNumber}
                                                className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                                readOnly
                                            />
                                        </div>
                                        <div>
                                            <label className="text-sm block mb-1">{t('invoice.originLocation')}</label>
                                            <input
                                                value={shipment.originLocation}
                                                className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                                readOnly
                                            />
                                        </div>
                                        <div>
                                            <label className="text-sm block mb-1">{t('invoice.destinationLocation')}</label>
                                            <input
                                                value={shipment.destinationLocation}
                                                className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                                readOnly
                                            />
                                        </div>
                                        <div>
                                            <label className="text-sm block mb-1">{t('invoice.description')}</label>
                                            <input
                                                value={shipment.description}
                                                onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                                className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                                required
                                            />
                                        </div>
                                        {formData.shipments.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => removeShipmentField(index)}
                                                className="text-red-500 text-sm mt-2"
                                            >
                                                {t('invoice.removeShipment')}
                                            </button>
                                        )}
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    onClick={addShipmentField}
                                    className="bg-[#6F1AFF] text-white px-4 py-2 rounded text-sm mb-4"
                                >
                                    {t('invoice.addAnotherShipment')}
                                </button>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.referenceNotes')}</label>
                                    <input
                                        name="referenceNotes"
                                        value={formData.referenceNotes}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.size')}</label>
                                    <input
                                        name="size"
                                        value={formData.size}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.deliveryDate')}</label>
                                    <input
                                        name="deliveryDate"
                                        type="date"
                                        value={formData.deliveryDate}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.address')}</label>
                                    <input
                                        name="address"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>

                                <h3 className="text-sm text-cyan-400 font-semibold mt-4">{t('invoice.companyClientInformation')}</h3>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.billFrom')}</label>
                                    <input
                                        name="billFrom"
                                        value={formData.billFrom}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.billTo')}</label>
                                    <select
                                        name="billTo"
                                        value={selectedClientId}
                                        onChange={(e) => setSelectedClientId(e.target.value)}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                        required
                                    >
                                        <option value="">{t('invoice.selectClient')}</option>
                                        {clientForm.map(client => (
                                            <option key={client._id} value={client._id}>
                                                {client.fullName} ({client.email})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.clientAddress')}</label>
                                    <input
                                        name="clientAddress"
                                        value={formData.clientAddress}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>

                                <h3 className="text-sm text-cyan-400 font-semibold mt-4">{t('invoice.lineItems')}</h3>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.quantity')}</label>
                                    <input
                                        name="quantity"
                                        type="number"
                                        value={formData.quantity}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.rate')}</label>
                                    <input
                                        name="rate"
                                        type="number"
                                        value={formData.rate}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.tax')}</label>
                                    <input
                                        name="tax"
                                        type="number"
                                        placeholder="Enter flat tax amount"
                                        value={formData.tax}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.total')}</label>
                                    <input
                                        name="total"
                                        value={formData.total}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                        readOnly
                                    />
                                </div>

                                <h3 className="text-sm text-cyan-400 font-semibold mt-4">{t('invoice.paymentInformation')}</h3>

                                {/* REPLACED BANK DETAILS WITH STRIPE NOTE */}
                                <div className="bg-[#1D2A85] p-3 rounded-lg border border-[#6E00FF] mb-4">
                                    <label className="text-sm block mb-1 text-cyan-400 font-semibold">Payment Gateway (Stripe)</label>
                                    <p className="text-xs text-gray-300">
                                        Bank details are not required. A secure Stripe checkout link will be automatically generated after submission, and you will be redirected to complete the payment.
                                    </p>
                                </div>

                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.shippingMethod')}</label>
                                    <input
                                        name="shippingMethod"
                                        value={formData.shippingMethod}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <div>
                                    <label className="text-sm block mb-1">{t('invoice.additionalNotesForClient')}</label>
                                    <textarea
                                        name="additionalNotesForClient"
                                        rows="3"
                                        value={formData.additionalNotesForClient}
                                        onChange={handleInputChange}
                                        className="w-full px-3 py-2 rounded bg-white text-black text-sm"
                                    />
                                </div>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className={`mt-6 w-full bg-[#792aff] text-white py-2 rounded-md font-semibold text-sm ${loading ? 'opacity-50 cursor-not-allowed' : ''
                                        }`}
                                >
                                    {loading ? t('invoice.submitting') : t('invoice.sendInvoice')}
                                </button>
                            </form>
                        </>
                    </div>
                </div>
            )}

            {isSuccessModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-[#0F0D2E] p-6 sm:p-8 rounded-2xl w-full sm:max-w-md text-center" style={{ backdropFilter: 'blur(42.7px)' }}>
                        <h2 style={{ fontFamily: "Poppins" }} className="text-xl sm:text-[30px] font-bold text-white leading-tight">
                            {t('invoice.invoiceCreated')} <span className="text-2xl sm:text-[45px] text-[#6F1AFF]">{t('invoice.successfully')}</span>
                        </h2>
                        <p className="text-sm text-gray-400 mb-4 sm:mb-6 mt-1">
                            {t('invoice.successMessage')}
                        </p>
                        <div className="flex justify-center mb-4 sm:mb-6">
                            <img src={check} alt={t('invoice.checkmarkAlt')} className="w-32 sm:w-[197px] h-24 sm:h-[156px]" />
                        </div>
                        <button
                            onClick={() => setIsSuccessModalOpen(false)}
                            className="w-full py-2 sm:py-3 bg-[#6F1AFF] text-white rounded-xl hover:opacity-90 transition font-medium text-sm"
                        >
                            {t('invoice.ok')}
                        </button>
                    </div>
                </div>
            )}

            <div className="overflow-x-auto bg-[#1D2461] rounded-lg">
                {loading && <p className="text-center p-4 text-sm">{t('invoice.loadingInvoices')}</p>}
                {!loading && invoices.length === 0 && (
                    <p className="text-center p-4 text-sm">{t('invoice.noInvoicesFound')}</p>
                )}
                {!loading && invoices.length > 0 && (
                    <table className="w-full table-auto text-xs sm:text-sm text-left">
                        <thead className="bg-[#B2BAFF] text-[#202224] font-nunito uppercase text-xs sm:text-[14px]">
                            <tr>
                                <th className="p-2 sm:p-4"><input type="checkbox" /></th>
                                <th className="p-2 sm:p-4">{t('invoice.invoiceNo')}</th>
                                <th className="p-2 sm:p-4">{t('invoice.poNo')}</th>
                                <th className="p-2 sm:p-4">{t('invoice.amount')}</th>
                                <th className="p-2 sm:p-4">{t('invoice.dateIssued')}</th>
                                <th className="p-2 sm:p-4">{t('invoice.dueDate')}</th>
                                <th className="p-2 sm:p-4">{t('invoice.status')}</th>
                                <th className="p-2 sm:p-4">{t('invoice.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {invoices.map((invoice) => (
                                <tr key={invoice._id} className="border-t border-[#2A2A4D]">
                                    <td className="p-2 sm:p-4"><input type="checkbox" /></td>
                                    <td className="p-2 sm:p-4">{invoice.invoiceNumber}</td>
                                    <td className="p-2 sm:p-4">{invoice.poNumber || '-'}</td>
                                    <td className="p-2 sm:p-4">
                                        ${parseFloat(invoice.total || 0).toFixed(2)}
                                    </td>
                                    <td className="p-2 sm:p-4">
                                        {invoice.invoiceDate ? format(new Date(invoice.invoiceDate), 'dd-MMM-yyyy', { locale }) : '-'}
                                    </td>
                                    <td className="p-2 sm:p-4">
                                        {invoice.dueDate ? format(new Date(invoice.dueDate), 'dd-MMM-yyyy', { locale }) : '-'}
                                    </td>
                                    <td className="p-2 sm:p-4">
                                        <span className={`px-2 py-1 rounded text-xs text-white ${invoice.status === 'Paid' ? 'bg-green-500' : 'bg-red-500'}`}>
                                            {invoice.status || 'Pending'}
                                        </span>
                                    </td>
                                    <td className="p-2 sm:p-4">
                                        <div className="flex gap-2">
                                            <button
                                                onClick={() => {
                                                    setSelectedInvoice(invoice);
                                                    setShowModal2(true);
                                                }}
                                                className="bg-[#00B69B] text-white px-3 sm:px-4 py-1 rounded-2xl hover:bg-blue-600 text-xs sm:text-sm"
                                            >
                                                {t('invoice.view')}
                                            </button>
                                            <button
                                                onClick={() => handleUpdateStatus(invoice)}
                                                className="bg-yellow-500 text-white px-3 sm:px-4 py-1 rounded-2xl hover:bg-yellow-600 text-xs sm:text-sm"
                                            >
                                                {t('invoice.update', { defaultValue: 'Update' })}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
                <div className="text-xs sm:text-sm text-gray-400 p-4">
                    {t('invoice.showingInvoices', { count: invoices.length })}
                </div>
            </div>

            {showModal2 && selectedInvoice && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                    <div
                        className="rounded-xl shadow-xl text-white p-4 sm:p-6 relative w-full sm:max-w-[480px] max-h-[90vh] overflow-y-auto hide-scrollbar"
                        style={{
                            background: "radial-gradient(50% 49.39% at 50% 50%, #1D2461 0%, #080625 100%)",
                        }}
                    >
                        <button
                            onClick={() => setShowModal2(false)}
                            className="absolute top-2 right-4 text-xl sm:text-2xl font-bold"
                        >
                            ×
                        </button>
                        <h2 className="text-lg sm:text-xl font-bold mb-4">{t('invoice.invoicePreview')}</h2>
                        <form className="space-y-4">
                            <div className="flex items-start gap-4 border border-[#D8D8D8] bg-[#1D2461] p-3 rounded-xl mb-6">
                                <div className="w-16 sm:w-20 h-16 sm:h-20 rounded-full bg-white text-black flex items-center justify-center text-center text-xs p-1">
                                    {t('invoice.companyLogo')}
                                </div>
                                <div>
                                    <h3 className="font-semibold text-base sm:text-lg">{t('invoice.containerMovementInvoice')}</h3>
                                    <p className="text-sm font-semibold">{selectedInvoice.invoiceNumber}</p>
                                    <p className="text-xs mt-2">
                                        {t('invoice.invoiceDate')}: {format(new Date(selectedInvoice.invoiceDate), 'dd MMMM yyyy', { locale })} -
                                        {t('invoice.dueDate')}: {format(new Date(selectedInvoice.dueDate), 'dd MMMM yyyy', { locale })}
                                    </p>
                                </div>
                            </div>
                            <div className="mb-4">
                                <label className="text-sm block mb-1">{t('invoice.to')}</label>
                                <input
                                    type="text"
                                    className="w-full px-3 py-2 bg-[#1D2461] rounded text-white text-sm"
                                    value={selectedInvoice.billTo}
                                    readOnly
                                />
                            </div>
                            <div className="overflow-x-auto">
                                <table className="min-w-full text-xs sm:text-sm text-left text-white border border-white rounded-2xl overflow-hidden">
                                    <thead className="bg-[#B2BAFF] text-black">
                                        <tr>
                                            <th className="px-2 sm:px-4 py-2">{t('invoice.description')}</th>
                                            <th className="px-2 sm:px-4 py-2">{t('invoice.rate')}</th>
                                            <th className="px-2 sm:px-4 py-2">{t('invoice.quantity')}</th>
                                            <th className="px-2 sm:px-4 py-2">{t('invoice.total')}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-[#1D2461] divide-y divide-white">
                                        {selectedInvoice.shipments?.map((shipment, index) => (
                                            <tr key={index}>
                                                <td className="px-2 sm:px-4 py-2">{shipment.description}</td>
                                                <td className="px-2 sm:px-4 py-2">${parseFloat(selectedInvoice.rate || 0).toFixed(2)}</td>
                                                <td className="px-2 sm:px-4 py-2">{selectedInvoice.quantity}</td>
                                                <td className="px-2 sm:px-4 py-2">${(selectedInvoice.rate * selectedInvoice.quantity).toFixed(2)}</td>
                                            </tr>
                                        ))}
                                        <tr>
                                            <td colSpan="2"></td>
                                            <td className="px-2 sm:px-4 py-2 font-semibold">{t('invoice.subtotal')}</td>
                                            <td className="px-2 sm:px-4 py-2">${(selectedInvoice.quantity * selectedInvoice.rate).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2"></td>
                                            <td className="px-2 sm:px-4 py-2 font-semibold">{t('invoice.tax')}</td>
                                            <td className="px-2 sm:px-4 py-2">${parseFloat(selectedInvoice.tax || 0).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan="2"></td>
                                            <td className="px-2 sm:px-4 py-2 text-cyan-400 font-bold">{t('invoice.totalAmount')}</td>
                                            <td className="px-2 sm:px-4 py-2 text-cyan-400 font-bold">${parseFloat(selectedInvoice.total || 0).toFixed(2)}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="mb-4">
                                <label className="text-sm block mb-1">{t('invoice.paymentMethod')}</label>
                                <input
                                    type="text"
                                    className="w-full px-3 py-2 bg-[#1D2461] rounded text-white text-sm"
                                    value={t(`invoice.paymentMethods.${selectedInvoice.paymentMethod.toLowerCase()}`, { defaultValue: selectedInvoice.paymentMethod })}
                                    readOnly
                                />
                            </div>

                            {/* ADDED STRIPE MESSAGE IN PREVIEW */}
                            <div className="mb-4 bg-[#1D2A85] p-3 rounded text-sm text-cyan-400 border border-gray-600">
                                <p className="font-semibold">Payment Gateway</p>
                                <p className="text-gray-300 text-xs">Secure online payment link processed via Stripe.</p>
                            </div>

                            <div className="mb-4">
                                <label className="text-sm block mb-1">{t('invoice.additionalNotes')}</label>
                                <textarea
                                    className="w-full px-3 py-2 bg-[#1D2461] rounded text-white text-sm"
                                    value={selectedInvoice.additionalNotesForClient}
                                    readOnly
                                />
                            </div>
                        </form>
                        <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
                            <button
                                onClick={() => downloadInvoicePDF(selectedInvoice)}
                                className="flex items-center gap-2 bg-[#00B69B] text-white py-2 px-4 rounded-md font-semibold text-sm"
                            >
                                {t('invoice.downloadInvoice')}
                            </button>
                            <button
                                onClick={() => setShowModal2(false)}
                                className="bg-[#6f1aff] text-white py-2 px-4 rounded-md font-semibold text-sm"
                            >
                                {t('invoice.close')}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {showUpdateModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                    <div
                        className="rounded-3xl shadow-2xl text-white p-6 sm:p-8 relative w-full max-w-[450px]"
                        style={{
                            background: "radial-gradient(100% 100% at 50% 0%, #1D2461 0%, #080625 100%)",
                            border: "1px solid rgba(111, 26, 255, 0.2)"
                        }}
                    >
                        <button
                            onClick={() => setShowUpdateModal(false)}
                            className="absolute top-4 right-6 text-2xl font-light hover:text-gray-300 transition-colors"
                        >
                            ×
                        </button>
                        
                        <div className="mb-6">
                            <h2 className="text-2xl font-bold tracking-tight mb-2">Update Invoice</h2>
                            <p className="text-sm text-gray-400">Modify the status and payment details for <span className="text-cyan-400 font-semibold">{updatingInvoice?.invoiceNumber}</span></p>
                        </div>

                        <form onSubmit={handleConfirmUpdate} className="space-y-6">
                            <div>
                                <label className="text-xs uppercase tracking-widest text-gray-500 font-bold block mb-2 ps-1">Status</label>
                                <div className="relative">
                                    <select
                                        value={updateFormData.status}
                                        onChange={(e) => setUpdateFormData({ ...updateFormData, status: e.target.value })}
                                        className="w-full px-4 py-3 rounded-xl bg-[#10194E] border border-[#1E2A60] text-white text-sm focus:border-[#6F1AFF] focus:ring-1 focus:ring-[#6F1AFF] outline-none transition-all appearance-none cursor-pointer"
                                        required
                                    >
                                        <option value="Pending">Pending</option>
                                        <option value="Paid">Paid</option>
                                        <option value="Failed">Failed</option>
                                        <option value="Cancelled">Cancelled</option>
                                    </select>
                                    <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
                                        <FiChevronDown />
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label className="text-xs uppercase tracking-widest text-gray-500 font-bold block mb-2 ps-1">Payment Method</label>
                                <input
                                    placeholder="e.g. Stripe, Bank Transfer"
                                    value={updateFormData.paymentMethod}
                                    onChange={(e) => setUpdateFormData({ ...updateFormData, paymentMethod: e.target.value })}
                                    className="w-full px-4 py-3 rounded-xl bg-[#10194E] border border-[#1E2A60] text-white text-sm focus:border-[#6F1AFF] focus:ring-1 focus:ring-[#6F1AFF] outline-none transition-all"
                                    required
                                />
                            </div>

                            <div className="flex gap-4 pt-4">
                                <button
                                    type="button"
                                    onClick={() => setShowUpdateModal(false)}
                                    className="flex-1 py-3 rounded-xl border border-[#1E2A60] text-sm font-semibold hover:bg-[#1E2A60] transition-colors"
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="flex-1 py-3 rounded-xl bg-gradient-to-r from-[#6E00FF] to-[#A627FF] text-sm font-semibold hover:opacity-90 shadow-[0_0_20px_rgba(110,0,255,0.3)] transition-all disabled:opacity-50"
                                >
                                    {loading ? 'Updating...' : 'Save Changes'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Invoice;